import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3017bde"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Login", -1))
const _hoisted_2 = { class: "item-container" }
const _hoisted_3 = { class: "form-item" }
const _hoisted_4 = { class: "error-message" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "username",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.username) = $event)),
            placeholder: "Username",
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearErrorMessage()))
          }, null, 544), [
            [_vModelText, _ctx.input.username]
          ]),
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "password",
            name: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.password) = $event)),
            placeholder: "Password",
            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearErrorMessage()))
          }, null, 544), [
            [_vModelText, _ctx.input.password]
          ]),
          _hoisted_6,
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login()))
          }, "Login")
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.guestLogin()))
          }, "Play as Guest")
        ])
      ])
    ]),
    _: 1
  }))
}